export default function (entity, collision) {

    const velocityComponent = this.snippets.common['get-velocity'](entity);

    if (collision.from.top === true) {

        velocityComponent.bottom = Math.max(velocityComponent.bottom, collision.delta.top);
    }

    if (collision.from.right === true) {

        velocityComponent.left = Math.max(velocityComponent.left, collision.delta.right);
    }

    if (collision.from.bottom === true) {

        velocityComponent.top = Math.max(velocityComponent.top, collision.delta.bottom);
    }

    if (collision.from.left === true) {

        velocityComponent.right = Math.max(velocityComponent.right, collision.delta.left);
    }
};
